import React, { useMemo } from 'react';
import { createPortal } from 'react-dom';
import { describe } from '@elliemae/ds-legacy-props-helpers';
import { PopoverContent } from './PopoverContent.js';
import { useConfigDSPopperjs } from './config/useConfigDSPopperjs.js';
import type { DSPopperJST } from './react-desc-prop-types.js';
import { dspopperjsPropTypes } from './react-desc-prop-types.js';

const DSPopperJS: React.ComponentType<DSPopperJST.Props> = (props) => {
  const {
    props: {
      showPopover,
      withoutAnimation,
      animationDuration,
      withoutPortal,
      withoutArrow,
      portalDOMContainer,
      zIndex,
      extraPopperStyles,
    },
    globalAttrs,
    xStyledAttrs,
    setPopperElement,
    setArrowElement,
    setIsAnimating,
    popoverHelper,
    isAnimating,
  } = useConfigDSPopperjs(props);
  const { children } = props;
  const { styles, attributes } = popoverHelper;
  const contentJSX = useMemo(
    () => (
      <PopoverContent
        setPopperElement={setPopperElement}
        popperStyles={{ ...styles.popper, ...extraPopperStyles }}
        popperAttributes={attributes.popper}
        setArrowElement={setArrowElement}
        arrowStyle={styles.arrow}
        withoutArrow={withoutArrow}
        withoutAnimation={withoutAnimation}
        animationDuration={animationDuration}
        zIndex={zIndex}
        showPopover={showPopover}
        setIsAnimating={setIsAnimating}
        globalAttrs={globalAttrs}
        xStyledAttrs={xStyledAttrs}
      >
        {children}
      </PopoverContent>
    ),
    [
      attributes.popper,
      children,
      setIsAnimating,
      showPopover,
      extraPopperStyles,
      setArrowElement,
      setPopperElement,
      styles.arrow,
      styles.popper,
      withoutArrow,
      withoutAnimation,
      animationDuration,
      zIndex,
      globalAttrs,
      xStyledAttrs,
    ],
  );
  if (showPopover || isAnimating) {
    if (withoutPortal === true) return contentJSX;
    if (portalDOMContainer && withoutPortal === false) return <>{createPortal(contentJSX, portalDOMContainer)}</>;
  }
  return null;
};

DSPopperJS.propTypes = dspopperjsPropTypes;
DSPopperJS.displayName = 'DSPopperJS';
const DSPopperJSWithSchema = describe(DSPopperJS).description('A dimsum custom styling wrapper on top of popperjs');
DSPopperJSWithSchema.propTypes = dspopperjsPropTypes;

export { DSPopperJS, DSPopperJSWithSchema };
export default DSPopperJS;

export type { DSPopperJST } from './react-desc-prop-types.js';
